import { TableRow } from '@mui/material';
import { CourseLeaderBoardTableRow, CourseParticipantsTableRow, CourseTableRow } from 'src/containers';

export const RenderTableRow = (name, data, index, actions) => {
  switch (name) {
    case 'course':
      return <CourseTableRow key={index} row={data} index={index} actions={actions} />;
    case 'participant':
      return <CourseParticipantsTableRow key={index} row={data} index={index} actions={actions} />;
    case 'leader-board':
      return <CourseLeaderBoardTableRow key={index} row={data} index={index} actions={actions} />;

    default:
      return <TableRow></TableRow>;
  }
};
